export const Steps = [
  {
    id: "general",
    order: 0,
    title: "General Info",
    completed: false,
    active: false,
    validated: false,
    fieldsValues: {
      customer: null,
      validity_start: null,
      customer_id: null,
      operator_id: null,
    },
  },
  {
    id: "services",
    order: 1,
    title: "Services Info",
    completed: false,
    active: false,
    validated: false,
    fieldsValues: {
      object_it: null,
      object_eng: null,
      incoterm: null,
      terminals: null,
      commodities: null,
      place_of_receipt_id: null,
      place_of_delivery_id: null,
      place_of_receipt: null,
      place_of_delivery: null,
      flow_of_goods: null,
      loading_port: null,
      discharge_port: null,
      loading_port_id: null,
      discharge_port_id: null,
      type_of_shipment: null,
      mode_of_transport: null,
      assigned_office_id: null,
      assigned_office: null,
      container_shipment_type: null,
    },
  },
  {
    id: "addServices",
    order: 2,
    title: "Add Services",
    completed: false,
    active: false,
    validated: false,
    fieldsValues: {
      prices: null,
    },
  },
  {
    id: "payment",
    order: 3,
    title: "Payment Details",
    completed: false,
    active: false,
    validated: false,
    fieldsValues: {
      validity_end: null,
      terms_of_payment_id: null,
      terms_of_payment: null,
    },
  },
  {
    id: "comment",
    order: 4,
    title: "Comment",
    completed: false,
    active: false,
    validated: false,
    fieldsValues: {
      terms_and_conditions: null,
      comment: null,
    },
  },
];

export const FLOW_OF_GOODS = ["Import"];
export const MODE_OF_TRANSPORT = [
  "Maritime Transport",
  "Land Transport",
  "Air Transport",
];
export const TYPE_OF_SHIPMENT = ["Container", "Bulk"];
export const AIR_TYPE_OF_SHIPMENT = ["Bulk"];

export const CONTAINER_SHIPMENT_TYPE = ["FCL", "LCL"];
export const INCOTERMS = [
  "EXW",
  "FCA",
  "CPT",
  "CFR/CIF",
  "CIP",
  "DAP",
  "DPU",
  "DDP",
  "FAS",
  "FOB",
  "CFR",
  "CIF",
  "DDU",
  "DAT",
];

export const TERMS_AND_CONDITIONS =
  "By accessing or using our services, you agree to comply with these Terms and Conditions. If you do not agree, please do not use our services. You must use our services lawfully and avoid any actions that may harm us or other users. If registration is required, you are responsible for maintaining the confidentiality and accuracy of your account details. All content provided through our services remains our property or the property of our licensors and may not be copied, modified, or distributed without permission. We are not responsible for any damages or losses resulting from the use of our services. Use them at your own risk. We reserve the right to update these Terms at any time. Continued use of our services constitutes acceptance of the revised terms.";
